import { BothModifiedConflict } from "@common/dto/financialAccount/mergeFinancialAccounts/both-modified-conflict.dto";
import { Transaction } from "@common/types/transaction";
import classNames from "classnames";
import gridTableStyles from "@general/Tables/GridTable/GridTableBase.module.scss";
import { FormCheckbox } from "@components/forms/FormCheckbox/FormCheckbox";
import { TransactionToMerge } from "./TransactionToMerge";
import styles from "./BothModifiedConflicts.module.scss";

interface Props {
    conflict: BothModifiedConflict;
    resolutions: number[];
    onResolve: (
        conflict: BothModifiedConflict,
        transaction: Transaction,
    ) => void;
}

export const BothModifiedConflictResolving: React.FC<Props> = ({
    conflict,
    resolutions,
    onResolve,
}) => (
    <div className={classNames(gridTableStyles.gridTable, styles.table)}>
        <div className={gridTableStyles.headerRow}>
            <div>Select</div>
            <div className={styles.headerCell}>In destination</div>
        </div>
        <TransactionToMerge
            transaction={conflict.transactionFromDestination}
            prepend={
                <div>
                    <FormCheckbox
                        type="radio"
                        isChecked={resolutions.includes(
                            conflict.transactionFromDestination.id,
                        )}
                        value={conflict.transactionFromDestination.id}
                        handleChange={() =>
                            onResolve(
                                conflict,
                                conflict.transactionFromDestination,
                            )
                        }
                    />
                </div>
            }
            onClick={() =>
                onResolve(conflict, conflict.transactionFromDestination)
            }
            className={styles.conflictRow}
        />
        <div className={gridTableStyles.headerRow}>
            <div className={styles.headerCell}>To merge</div>
        </div>
        <TransactionToMerge
            transaction={conflict.transactionFromMerged}
            prepend={
                <div>
                    <FormCheckbox
                        type="radio"
                        isChecked={resolutions.includes(
                            conflict.transactionFromMerged.id,
                        )}
                        value={conflict.transactionFromMerged.id}
                        handleChange={() =>
                            onResolve(conflict, conflict.transactionFromMerged)
                        }
                    />
                </div>
            }
            onClick={() => onResolve(conflict, conflict.transactionFromMerged)}
            className={styles.conflictRow}
        />
    </div>
);
